import React from 'react';
import { css } from '@emotion/react';
import { GoogleStarIcon } from '../../icons';
import { theme } from '@frontend/theme';

type Props = {
  rating?: number;
  maxRating?: number;
};

export const GoogleRating = ({ rating = 0, maxRating = 5, ...rest }: Props) => {
  const stars = [] as React.ReactNode[];

  for (let i = 0; i < maxRating; i++) {
    const percent = Math.max(rating - i, 0);
    const StyledStarIcon = (
      <GoogleStarIcon
        key={i}
        css={css`
          margin-right: ${theme.spacing(0.25)};
          display: unset;
        `}
        fillRatio={percent}
      />
    );
    stars.push(StyledStarIcon);
  }
  return (
    <div
      css={css`
        display: flex;
        align-items: center;
      `}
      {...rest}
    >
      {stars}
    </div>
  );
};
